module.exports = __webpack_public_path__ + "img/promo-4-mock.8de13f84.png";